import React from "react";
import { Link, LinkProps } from "src/components/base/link";
import clsx from "clsx";
import { ChevronRightIcon } from "@heroicons/react/16/solid";

/**
 * A breadcrumb entry — same shape as the one used by `HeadingLayout`.
 */
export type Breadcrumb = {
    label: string;
    to?: LinkProps["href"];
    params?: LinkProps["params"];
    search?: LinkProps["search"];
};

/**
 * A breadcrumb navigation.
 */
export default function Breadcrumbs({ items }: { items: Array<Breadcrumb> }) {
    return (
        <nav aria-label="Breadcrumb" className={"flex items-center gap-1 text-sm/5 text-zinc-500 dark:text-zinc-400"}>
            {items.map((item, idx) => {
                const isLast = idx === items.length - 1;
                return (
                    <React.Fragment key={`${idx}-${item.label}`}>
                        {item.to && !isLast ? (
                            <Link
                                href={item.to}
                                params={item.params}
                                search={item.search}
                                className={
                                    "rounded px-0.5 hover:text-zinc-700 focus:outline-2 focus:outline-offset-2 focus:outline-(--color-brand-500) dark:hover:text-zinc-200"
                                }
                            >
                                {item.label}
                            </Link>
                        ) : (
                            <span
                                className={clsx("px-0.5", isLast && "font-medium text-zinc-700 dark:text-zinc-200")}
                                aria-current={isLast ? "page" : undefined}
                            >
                                {item.label}
                            </span>
                        )}
                        {!isLast && <ChevronRightIcon className={"size-3.5 shrink-0 opacity-50"} />}
                    </React.Fragment>
                );
            })}
        </nav>
    );
}
